import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import PropTypes from "prop-types";

const features = [
    {
        title: "1 in 3 people",
        desc: "say they do not have enough life insurance.",
    },
    {
        title: "1/2",
        desc: "Half of the population estimates the cost of life insurance at more than three times the actual cost.",
    },
    {
        title: "40%",
        desc: "of insured people wish they had purchased their policies at a younger age.",
    },
    {
        title: "Financial Impact of Losing the Primary Earner",
        desc: "If the primary wage earner passes away, 44% of consumers surveyed reported that they would feel a financial impact within six months and 28% within one month.",
    },
    {
        title: "Top 3 reasons people buy life insurance",
        desc: "39% Replace income | 18% Pay off mortgage | 18% Transfer wealth",
    },
];

const FeaturedItem = ({ feature, index }) => {
    return (
        <div
            className={classNames(
                "bg-skyBlue  flex items-center rounded-xl p-4",
                { "mb-4": index !== features.length - 1 }
            )}
        >
            <div className="flex justify-center items-center text-[15px] p-3 bg-darkBlue text-white rounded-full mr-3">
                <FontAwesomeIcon icon={faCheck} />
            </div>
            <div>
                <h4 className="text-[17px] font-bold">{feature.title}</h4>
                <p className="text-[17px]">{feature.desc}</p>
            </div>
        </div>
    );
};

FeaturedItem.propTypes = {
    feature: PropTypes.object.isRequired,
    index: PropTypes.number,
};

const Facts = () => {
    return (
        <section className="py-20 md:py-26 bg-skyBlue relative overflow-hidden z-10">
            <div className="max-w-7xl px-4 mx-auto">
                <div className="flex justify-center text-center mx-auto">
                    <div>
                        <h1 className="text-3xl font-bold leading-tight md:text-[40px] mb-12 uppercase">
                            5 Facts about Life Insurance
                        </h1>
                    </div>
                </div>
                <div className="flex justify-center">
                    <div className="max-w-3xl w-full">
                        {features.map((feature, i) => (
                            <FeaturedItem feature={feature} key={i} index={i} />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Facts